/* eslint-disable prettier/prettier */
export const MessagesList = {
  2: { parts_length: 0 },
  59: ['string'],
  60: {
    parts_length: 1,
    data: [{ name: 'settings', type: 'string' }],
  },
  61: ['string'],
  63: {
    parts_length: 12,
    data: [
      { name: 'serverSeedSHA256', type: 'string' },
      { name: 'clientSeed', type: 'string' },
      { name: 'nonce', type: 'int' },
      { name: 'balance', type: 'number' },
      { name: 'user_id', type: 'string' },
      { name: 'user_name', type: 'base64' },
      {
        name: 'game_settings',
        type: 'objects',
        delimeter: '|',
        parts_length: 2,
        obj: [{ name: 'dealer_rake', type: 'number' }],
      },
      { name: 'minBet', type: 'number' },
      { name: 'maxBet', type: 'number' },
      { name: 'currency', type: 'string' },
      { name: 'precision', type: 'number' },
      { name: 'next_server_seed_SHA256', type: 'string' },
    ],
  },
  64: ['number', 'number', 'number'],
  65: {
    parts_length: 9,
    data: [
      { name: 'betid', type: 'string' },
      { name: 'winAmount', type: 'number' },
      { name: 'betAmount', type: 'number' },
      { name: 'balance', type: 'number' },
      { name: 'balance_before', type: 'number' },
      { name: 'win_seat', type: 'string' },
      {
        name: 'banker',
        type: 'objects',
        delimeter: ':',
        parts_length: 6,
        obj: [
          { name: 'type', type: 'string' },
          { name: 'bet', type: 'number' },
          { name: 'win', type: 'number' },
          { name: 'mult', type: 'number' },
          { name: 'point', type: 'number' },
          { name: 'points', type: 'array', delimeter: ';' },
          { name: 'cards', type: 'array', delimeter: ';' },
        ],
      },
      {
        name: 'player',
        type: 'objects',
        delimeter: ':',
        parts_length: 6,
        obj: [
          { name: 'type', type: 'string' },
          { name: 'bet', type: 'number' },
          { name: 'win', type: 'number' },
          { name: 'mult', type: 'number' },
          { name: 'point', type: 'number' },
          { name: 'points', type: 'array', delimeter: ';' },
          { name: 'cards', type: 'array', delimeter: ';' },
        ],
      },
      {
        name: 'tie',
        type: 'objects',
        delimeter: ':',
        parts_length: 6,
        obj: [
          { name: 'type', type: 'string' },
          { name: 'bet', type: 'number' },
          { name: 'win', type: 'number' },
          { name: 'mult', type: 'number' },
          { name: 'point', type: 'number' },
          { name: 'points', type: 'array', delimeter: ';' },
          { name: 'cards', type: 'array', delimeter: ';' },
        ],
      },
    ],
  },
  67: {
    parts_length: 13,
    data: [
      { name: 'round_id', type: 'string' },
      { name: 'user_name', type: 'base64' },
      { name: 'user_id', type: 'string' },
      { name: 'betAmount', type: 'number' },
      { name: 'winAmount', type: 'number' },
      { name: 'winCoef', type: 'number' },
      { name: 'currency', type: 'string' },
      { name: 'bigWin', type: 'int' },
      { name: 'bet_id', type: 'int' },
      { name: 'history', type: 'int' },
      { name: 'time', type: 'string' },
      { name: 'gameplay', type: 'string' },
      { name: 'sessionNo', type: 'string' },
    ],
  },
  72: ['number'],
  90: {
    parts_length: 1,
    data: [{ name: 'errorCode', type: 'int' }],
  },
  101: ['string'],
  116: ['string'],
  117: {
    parts_length: 18,
    data: [
      { name: 'user_id', type: 'string' },
      { name: 'user_name', type: 'base64' },
      { name: 'bet_id', type: 'int' },
      { name: 'round_id', type: 'string' },
      { name: 'betAmount', type: 'number' },
      { name: 'winAmount', type: 'number' },
      { name: 'currency', type: 'string' },
      { name: 'winCoef', type: 'number' },
      { name: 'bigWin', type: 'int' },
      { name: 'server_seed', type: 'string' },
      { name: 'server_seed_SHA256', type: 'string' },
      { name: 'client_seed', type: 'string' },
      { name: 'nonce', type: 'int' },
      { name: 'date', type: 'string' },
      {
        name: 'banker',
        type: 'objects',
        delimeter: ':',
        parts_length: 6,
        obj: [
          { name: 'type', type: 'string' },
          { name: 'bet', type: 'number' },
          { name: 'win', type: 'number' },
          { name: 'mult', type: 'number' },
          { name: 'point', type: 'number' },
          { name: 'points', type: 'array', delimeter: ';' },
          { name: 'cards', type: 'array', delimeter: ';' },
        ],
      },
      {
        name: 'player',
        type: 'objects',
        delimeter: ':',
        parts_length: 6,
        obj: [
          { name: 'type', type: 'string' },
          { name: 'bet', type: 'number' },
          { name: 'win', type: 'number' },
          { name: 'mult', type: 'number' },
          { name: 'point', type: 'number' },
          { name: 'points', type: 'array', delimeter: ';' },
          { name: 'cards', type: 'array', delimeter: ';' },
        ],
      },
      {
        name: 'tie',
        type: 'objects',
        delimeter: ':',
        parts_length: 6,
        obj: [
          { name: 'type', type: 'string' },
          { name: 'bet', type: 'number' },
          { name: 'win', type: 'number' },
          { name: 'mult', type: 'number' },
          { name: 'point', type: 'number' },
          { name: 'points', type: 'array', delimeter: ';' },
          { name: 'cards', type: 'array', delimeter: ';' },
        ],
      },
      { name: 'win_seat', type: 'string' },
    ],
  },
  118: ['string'],
  119: {
    parts_length: 8,
    data: [
      { name: 'server_seed_SHA256', type: 'string' },
      { name: 'client_seed', type: 'string' },
      { name: 'nonce', type: 'int' },

      { name: 'old_server_seed', type: 'string' },
      { name: 'old_server_seed_SHA256', type: 'string' },
      { name: 'old_client_seed', type: 'string' },
      { name: 'old_nonce', type: 'int' },
      { name: 'next_server_seed_SHA256', type: 'string' },
    ],
  },
};
